<script setup lang="ts">
import { computed } from 'vue';
import { coverPalette, initials } from '@/utils/format';

const props = withDefaults(
  defineProps<{ name: string | null | undefined; seed?: number; size?: number }>(),
  { seed: 0, size: 44 },
);
const cls = computed(() => `cv-${coverPalette(props.seed || (props.name?.length ?? 1))}`);
</script>

<template>
  <span
    class="avatar"
    :class="cls"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      fontSize: `${Math.round(size * 0.4)}px`,
    }"
    aria-hidden="true"
    >{{ initials(name) }}</span
  >
</template>
